import * as Types from '@theme/js/hooks/socket/types';

export const STACK: Types.ISocketStackEntry[] = [];

export const SEND_SYMBOL = Symbol('send');

// region Cashier

export enum CASHIER_TYPE {
    DEPOSIT = 'deposit',
    WITHDRAWAL = 'withdraw'
}

export enum CASHIER_FIELD_TYPE {
    DROPDOWN = 'dropdown',
    CHECKBOX = 'checkbox',
    COUNTRY = 'country',
    ENCRYPTED = 'sensitive',
    EXP_DATE = 'yearAndMonth',
    PASSWORD = 'password',
    PHONE = 'phone',
    RADIO = 'radiobuttons',
    TEXT = 'regular',
}

export enum PAYMENT_METHODS_CODES {
    P24_BLIK = 'P24Blik', /* TotalCasino changes */
    P24_CARD = 'P24Card', /* TotalCasino changes */
    BANK_TRANSFER_WDPL2 = 'BankTransferWDPL2', /* TotalCasino changes */
    DOTPAY_BANK_TRANSFER = 'DotpayBankTransfer',
    DOTPAY_BLIK = 'DotpayBlik',
    DOTPAY_CARD = 'DotpayCard',
    EASYCC = 'EasyCC',
    NUVEI_CC = 'CC',
    PAYPAL_VIA_SC = 'PayPalViaSC',
    PRAXIS = 'PraxisCard',
}

export enum CASHIER_REDIRECT_TYPE {
    IFRAME = 'iframe',
    JS_EASY_PG = 'jseasypg',
    JS_NUVEI = 'jsnuvei',
    JS_PAY_SAFE = 'jspaysafe',
    LIGHT_BOX = 'lightboxdt',
    POPUP = 'popup',
    PRAXIS = 'jspraxis',
    REDIRECT = 'redirect',
    SEAMLESS_WC = 'seamlesswc'
}

// endregion
